module.exports = __webpack_public_path__ + "a4aef5ec5cdea5c8f62caee6bf1f9a97.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/lk.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/lk.svg
// module chunks = 0